var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategoria(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 31,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.0739 48.1882H34.0619C32.8369 48.1882 31.8359 47.1872 31.8359 45.9622V33.9467C31.8359 32.7217 32.8369 31.7207 34.0619 31.7207H46.0739C47.2989 31.7207 48.2999 32.7217 48.2999 33.9467V45.9587C48.2999 47.1837 47.2989 48.1882 46.0739 48.1882Z",
    fill: "#BA0E1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.238 48.1882H16.226C15.001 48.1882 14 47.1872 14 45.9622V33.9467C14 32.7217 15.001 31.7207 16.226 31.7207H28.238C29.463 31.7207 30.464 32.7217 30.464 33.9467V45.9587C30.464 47.1837 29.463 48.1882 28.238 48.1882Z",
    fill: "#BA0E1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.238 30.4675H16.226C15.001 30.4675 14 29.4665 14 28.2415V16.226C14 15.001 15.001 14 16.226 14H28.238C29.463 14 30.464 15.001 30.464 16.226V28.238C30.464 29.4665 29.463 30.4675 28.238 30.4675Z",
    fill: "#BA0E1C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0739 30.4675H34.0619C32.8369 30.4675 31.8359 29.4665 31.8359 28.2415V16.226C31.8359 15.001 32.8369 14 34.0619 14H46.0739C47.2989 14 48.2999 15.001 48.2999 16.226V28.238C48.2999 29.4665 47.2989 30.4675 46.0739 30.4675ZM47.2639 27.762V16.7055C47.2639 15.7885 46.5149 15.036 45.5944 15.036H34.5414C33.6244 15.036 32.8719 15.785 32.8719 16.7055V27.762C32.8719 28.679 33.6209 29.4315 34.5414 29.4315H45.5979C46.5149 29.428 47.2639 28.679 47.2639 27.762Z",
    fill: "#BA0E1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoria);
export default __webpack_public_path__ + "static/media/categoria.1ebc1d4de7aac7bf9bae7a797d457d4c.svg";
export { ForwardRef as ReactComponent };